import type { FilterValue } from '@/components/Table/types';

export function getDefaultEvidenceFiltersForMapping(
  mappingContent:
    | { name: string; selectedPmYear?: number; selectedReferenceType?: 'PMID' | 'NCTID' | 'ALL' }
    | undefined,
): FilterValue[] | undefined {
  if (!mappingContent) return undefined;

  if (mappingContent.name === 'numPMIDsupportingAssociation') {
    const selectedType = mappingContent.selectedReferenceType ?? 'PMID';
    const base: FilterValue[] =
      selectedType === 'ALL'
        ? []
        : [{ name: 'reference_type', operator: 'eq', type: 'select', value: [selectedType] }];
    if (mappingContent.selectedPmYear != null && Number.isFinite(Number(mappingContent.selectedPmYear))) {
      const y = Number(mappingContent.selectedPmYear);
      base.push({
        name: 'pmYear',
        operator: 'eq',
        type: 'number',
        integer: true,
        value: String(y),
      });
    }
    return base;
  }

  if (mappingContent.name === 'numCTsSupportingAssociation' || mappingContent.name === 'numCTs') {
    return [{ name: 'reference_type', operator: 'eq', type: 'select', value: ['NCTID'] }];
  }

  return undefined;
}
